<template>
    <div :id="'module_' + dataId" class="module_newcar" :data-positionindex="dataPositionindex" :data-id="dataId">
        <div v-if="isShow"
            :is="template"
            :carList="carList"></div>
    </div>
</template>

<script>
import TemplateAmyOrBetty from './TemplateAmyOrBetty.vue';
import TemplateCrystalOrSouche from './TemplateCrystalOrSouche.vue';

export default {
    props: ['dataId', 'dataPositionindex'],
    components: {
        TemplateAmyOrBetty,
        TemplateCrystalOrSouche
    },
    data() {
        return {
            isShow: true
        };
    },
    computed: {
        carList() {
            return window._qiwa.site_global.recommList;
        },
        templateId() {
            return window._qiwa.sys_global.__basic_template_id;
        },
        template() {
            if (this.templateId === 'template_amy' || this.templateId === 'template_betty') {
                return 'TemplateAmyOrBetty';
            } else if (this.templateId === 'template_crystal' || this.templateId === 'template_souche') {
                return 'TemplateCrystalOrSouche';
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// Default.vue?58c77ad6